import { useNavigate } from "react-router-dom";
import styles from "../../styles/Blog/Blog.module.css";
import { base_url } from "../../ReuableFunctions/Blogs";

const PopularPost = ({ data }) => {
  const navigate = useNavigate();

  function handleRedirect(blogId){
    console.log("Rediecting to the blog", blogId);
    navigate(`/blog/${blogId}`)
  }
  return (
    <div className={styles.popularContainer} onClick={()=>handleRedirect(data?.["blogId"])} style={{cursor:"pointer"}}>
      <div className={styles.popularInnerContainer}>
        <div className={styles.popularLeftContainer}>
          <div className={styles.popularLeftImage}>
            <img src={`${base_url}/blog-image/${data?.["blogId"]}`} className={styles.Image} alt="blog-image" loading="lazy" />
          </div>
        </div>
        <div className={styles.popularRightContainer}>
          <div className={styles.popularRightTagsContainer}>
            {data["blogCategory"] &&
              data["blogCategory"] !== "" &&
              data["blogCategory"].split(",").map((category, index) => (
                <span className={styles.popularRightTag} key={index}>
                  {category}
                </span>
              ))}
          </div>
          <div className={styles.popularRightTitle}>
            {data.blogTitle || "Dummy title"}
          </div>
          <div className={styles.popularRightNameAndTitleContainer}>
            <div className={styles.popularRightImageAndNameContainer}>
              <span className={styles.popularRightImage}></span>
              <span className={styles.popularRightName}>
                {data.authorName || "Mohit Valecha"}
              </span>
            </div>
            {/* <div className={styles.popularRightReadAndTimeContainer}>
              <img
                src="/white-clock.svg"
                alt="clock_icon"
                className={styles.popularImgage}
              />
              <span className={styles.popularRightRead}>
                {data.read || "10"} min read
              </span>
            </div> */}
          </div>
        </div>
      </div>
    </div>
  );
};

export default PopularPost;
